import { Component, OnInit } from '@angular/core';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { AccessService } from '../../services/access.service';

@Component({
  selector: 'app-adm',
  templateUrl: './adm.component.html',
  styleUrl: './adm.component.scss'
})
export class AdmComponent implements OnInit {

  rol = '';
  result: any;
  accesses: any;
  accesses2: any;
  links: any;
  constructor(
    private tokenStorageService: TokenStorageService,
    private accessService: AccessService
  ) { }

  ngOnInit() {
    this.rol = this.tokenStorageService.getUser().role;
    this.getAccessUserLoged(this.tokenStorageService.getUser().id);

  }

  //Metodo para conseguir los modulos y permisos del usuario logeado
  getAccessUserLoged(id: string) {
    this.accessService.getAccess(id).subscribe({
      next: res => {
        this.result = (((res['data'])['0'])['accesses']);
      },
      error: err => { }
    });
  }
}
